<template>
<svg data-svg-lvl-3="flyleaffront-block-flyleaffront" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Форзац"><path class="lff-c-3" d="M256.74,86.62V348.09H434.61a12,12,0,0,0,12-12V98.62a12,12,0,0,0-12-12Z"/><path class="lff-c-3" d="M78.88,93.63h166a0,0,0,0,1,0,0v259.1a0,0,0,0,1,0,0h-166a12,12,0,0,1-12-12V105.63A12,12,0,0,1,78.88,93.63Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.lff-c-1{opacity:0.3;}.lff-c-2{fill:#64ff00;}.lff-c-3{fill:#f4e8ce;}</style>

